module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAZCAYAAAD5e+QFAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAAwSURBVChTY/jw4cN/dAwW/PXrFxhjCD58+PD/jh07EIIgDBLAEETGo2YOdjM//AcAF0jRYWi2NE4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/icons1.png
// module id = 9JCy
// module chunks = 1